import React from 'react';
import { styled, SubTitle, CommonStyles } from '@teko/ds-foundation';
import { BackOutlined, DotOutlined, ForwardOutlined } from '@teko/ds-icon';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SubTitle13 = styled(SubTitle)``;
const BasePage = styled.div`
  z-index: 1;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const InteractPage = styled(BasePage)(({ theme, active, disabled, color }) => `
border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
background-color: ${active ? (theme == null ? void 0 : theme.colors[color]) || color : theme == null ? void 0 : theme.colors.white};
border: ${active ? "none" : `1px solid ${theme == null ? void 0 : theme.colors.divider}`};
pointer-events: ${disabled ? "none" : "auto"};
${!active ? `
  cursor: pointer;
  &:hover {
    path[stroke],
    rect[stroke],
    line {
      stroke: ${theme == null ? void 0 : theme.colors.white};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${theme == null ? void 0 : theme.colors.white};
    }
    ${SubTitle13} {
      color: ${theme == null ? void 0 : theme.colors.white};
    }
    background-color: ${theme == null ? void 0 : theme.colors.background};
  }` : `
  ${SubTitle13} {
    color: ${theme == null ? void 0 : theme.colors.white};
  }
`}
`);
const PaginationWrap = styled.div`
  display: inline-flex;
  > *:not(:first-child) {
    margin-left: ${({ theme }) => theme == null ? void 0 : theme.spacing.s8};
  }
`;
const StyledPagination = styled.div`
  ${CommonStyles};
  width: 100%;
  text-align: ${(p) => p.align};
`;
const range = (from, to) => {
  return Array.from({ length: to - from + 1 }, (v, k) => k + from);
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const generatePageNumbers = (totalPages, currentPage, pageNeighbor) => {
  const totalNumbers = pageNeighbor * 2 + 3;
  const totalBlocks = totalNumbers + 2;
  if (totalPages > totalBlocks) {
    let pages = [];
    const curr = currentPage > totalPages ? totalPages : currentPage;
    const leftBound = curr - pageNeighbor;
    const rightBound = curr + pageNeighbor;
    const beforeLastPage = totalPages - 1;
    const startPage = leftBound > 2 ? leftBound : 2;
    const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
    pages = range(startPage, endPage);
    const pagesCount = pages.length;
    const singleSpillOffset = totalNumbers - pagesCount - 1;
    const leftSpill = startPage > 2;
    const rightSpill = endPage < beforeLastPage;
    const leftSpillPage = LEFT_PAGE;
    const rightSpillPage = RIGHT_PAGE;
    if (leftSpill && !rightSpill) {
      const extraPages = range(startPage - singleSpillOffset, startPage - 1);
      pages = [leftSpillPage, ...extraPages, ...pages];
    } else if (!leftSpill && rightSpill) {
      const extraPages = range(endPage + 1, endPage + singleSpillOffset);
      pages = [...pages, ...extraPages, rightSpillPage];
    } else if (leftSpill && rightSpill) {
      pages = [leftSpillPage, ...pages, rightSpillPage];
    }
    return [1, ...pages, totalPages];
  }
  return range(1, totalPages);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords,
    currentPage,
    pageLimit = 30,
    pageNeighbor = 2,
    onPageChange,
    align = "center",
    color = "primary500",
    itemRender
  } = _b, rest = __objRest(_b, [
    "totalRecords",
    "currentPage",
    "pageLimit",
    "pageNeighbor",
    "onPageChange",
    "align",
    "color",
    "itemRender"
  ]);
  var _a2;
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChange == null ? void 0 : onPageChange(page);
  };
  const onBackward = () => {
    gotoPage(currentPage - 1);
  };
  const onForward = () => {
    gotoPage(currentPage + 1);
  };
  const pages = generatePageNumbers(totalPages, currentPage, pageNeighbor);
  return /* @__PURE__ */ React.createElement(StyledPagination, __spreadValues({
    align
  }, rest), /* @__PURE__ */ React.createElement(PaginationWrap, null, (itemRender == null ? void 0 : itemRender["pre"]) ? (_a2 = itemRender["pre"]) == null ? void 0 : _a2.call(itemRender, currentPage - 1, {
    color,
    disabled: currentPage === 1
  }) : /* @__PURE__ */ React.createElement(InteractPage, {
    color,
    disabled: currentPage === 1,
    onClick: onBackward
  }, /* @__PURE__ */ React.createElement(BackOutlined, {
    size: 16,
    color: "placeholder"
  })), pages.map((page, index) => {
    var _a3;
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page.toString())) {
      return /* @__PURE__ */ React.createElement(BasePage, {
        key: index
      }, /* @__PURE__ */ React.createElement(DotOutlined, {
        size: 16,
        color: "border"
      }));
    }
    const isActive = page === currentPage;
    return (itemRender == null ? void 0 : itemRender["page"]) ? (_a3 = itemRender["page"]) == null ? void 0 : _a3.call(itemRender, page, {
      color,
      active: isActive
    }) : /* @__PURE__ */ React.createElement(InteractPage, {
      color,
      active: isActive,
      key: index,
      onClick: isActive ? void 0 : () => onPageChange == null ? void 0 : onPageChange(typeof page === "string" ? parseInt(page) : page)
    }, /* @__PURE__ */ React.createElement(SubTitle13, {
      level: 4,
      color: isActive ? "white" : "textPrimary"
    }, page));
  }), (itemRender == null ? void 0 : itemRender["next"]) ? itemRender["next"](currentPage + 1, {
    color,
    disabled: currentPage === 1
  }) : /* @__PURE__ */ React.createElement(InteractPage, {
    color,
    disabled: currentPage === totalPages,
    onClick: onForward
  }, /* @__PURE__ */ React.createElement(ForwardOutlined, {
    size: 16,
    color: "placeholder"
  }))));
};

export { Pagination };
